var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.918,
    height: 16.91,
    viewBox: "0 0 16.918 16.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_21_",
    "data-name": "calendar (21)",
    transform: "translate(0 -0.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M13.652,1.413h-.631V.775a.661.661,0,1,0-1.321,0v.639H5.218V.775A.661.661,0,1,0,3.9.775v.639H3.266A3.27,3.27,0,0,0,0,4.679v9.079a3.27,3.27,0,0,0,3.266,3.266H13.652a3.27,3.27,0,0,0,3.266-3.266V4.679a3.27,3.27,0,0,0-3.266-3.266ZM3.266,2.734H3.9V4.022a.661.661,0,0,0,1.321,0V2.734H11.7V4.022a.661.661,0,1,0,1.321,0V2.734h.631A1.947,1.947,0,0,1,15.6,4.679V5.31H1.321V4.679A1.947,1.947,0,0,1,3.266,2.734ZM13.652,15.7H3.266a1.947,1.947,0,0,1-1.945-1.945V6.632H15.6v7.127A1.947,1.947,0,0,1,13.652,15.7ZM5.868,9.23a.661.661,0,0,1-.661.661h-1.3a.661.661,0,1,1,0-1.321h1.3A.661.661,0,0,1,5.868,9.23Zm7.8,0a.661.661,0,0,1-.661.661h-1.3a.661.661,0,1,1,0-1.321h1.3A.661.661,0,0,1,13.67,9.23Zm-3.9,0A.661.661,0,0,1,9.1,9.89h-1.3a.661.661,0,1,1,0-1.321H9.1A.661.661,0,0,1,9.765,9.23Zm-3.9,3.9a.661.661,0,0,1-.661.661h-1.3a.661.661,0,1,1,0-1.321h1.3A.661.661,0,0,1,5.868,13.127Zm7.8,0a.661.661,0,0,1-.661.661h-1.3a.661.661,0,1,1,0-1.321h1.3A.661.661,0,0,1,13.67,13.127Zm-3.9,0a.661.661,0,0,1-.661.661h-1.3a.661.661,0,1,1,0-1.321H9.1A.661.661,0,0,1,9.765,13.127Z",
    fill: "#193863"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.4749902d8e62f4f6565f348fd90ad8be.svg";
export { ForwardRef as ReactComponent };